import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { ACTION_BACK_PATH, LAB_TEST_REPORTS_PATH } from '@shared/constants/paths';
import type { RouteConfig } from '@shared/types/common.types';

const LabTestReportsPage = lazy(() => import('@features/Mobile/LabTestReports/pages/LabTestReportsPage'));

export const LAB_TEST_REPORTS_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <LabTestReportsPage />,
    displayTitle: () => 'Lab Test Reports',
    pageType: PageType.PRIVATE,
    path: LAB_TEST_REPORTS_PATH,
    serviceCatalogCode: '',
  },
];
